interface PageHeaderProps {
  title: string;
  actions?: React.ReactNode;
  /** Keep title and actions on one row on all breakpoints (e.g. dashboard refresh beside title). */
  actionsInline?: boolean;
}

export const PageHeader = ({ title, actions, actionsInline }: PageHeaderProps) => {
  return (
    <div
      className={
        actionsInline
          ? 'flex min-w-0 items-center justify-between gap-3'
          : 'flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3'
      }
    >
      <h1
        className={
          actionsInline ? 'min-w-0 flex-1 truncate' : 'w-full min-w-0 sm:flex-1 sm:truncate'
        }
      >
        {title}
      </h1>
      {actions && (
        <div
          className={
            actionsInline
              ? 'flex shrink-0 flex-wrap items-center justify-end gap-2 sm:gap-3'
              : 'flex w-full min-w-0 flex-wrap items-center gap-2 sm:w-auto sm:shrink-0 sm:justify-end sm:gap-3'
          }
        >
          {actions}
        </div>
      )}
    </div>
  );
};
